import { render } from "./HeroiconsOutlineLightBulb.vue?vue&type=template&id=16528082"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLightBulb.vue"]])

export default __exports__